module.exports = __webpack_public_path__ + "static/media/20180423_184232.50c1965d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-pl/20180423_184232.jpg
// module id = 480
// module chunks = 0